export default __webpack_public_path__ + "static/media/fizzbuzz.7a021070.svg";